import { AppPageFrame } from "@interface48/app";
import Button from "@material-ui/core/Button";
import { createStyles, Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";
import React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { VideosTable } from "../../../components/videos";
import { actionCreators, AdministrationActions, AdministrationState, ApplicationState } from "../../../store";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      margin: theme.spacing(2),
    },
    button: {
      marginLeft: "auto",
      marginBottom: theme.spacing(2),
    },
  });

interface VideosIndexPageStateProps {
  administrationState: AdministrationState;
}

interface VideosIndexPageDispatchProps {
  administrationActions: AdministrationActions;
}

interface VideosIndexPageOwnProps extends RouteComponentProps<any>, WithStyles<typeof styles> {}

type VideosIndexPageProps = VideosIndexPageStateProps & VideosIndexPageDispatchProps & VideosIndexPageOwnProps;

const VideosIndexPageComponent = class extends React.Component<VideosIndexPageProps> {
  public componentDidMount() {
    const { administrationActions } = this.props;

    administrationActions.requestVideos();
  }

  public render() {
    const { administrationState, classes } = this.props;
    const { videos, actionStatus } = administrationState;

    const windowWidth = window.innerWidth;
    const isTableLoading =
      actionStatus && actionStatus.type === "ADMINISTRATION_VIDEOS_REQUEST" && actionStatus.pending;

    return (
      <AppPageFrame pageTitle="Videos" fullWidth={true} onBackClick={this.handleBackClick}>
        <div className={classes.root}>
          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            component={Link}
            to="/administration/videos/add"
          >
            Add Video
          </Button>
          <VideosTable results={videos ?? []} width={windowWidth} isLoading={isTableLoading} />
        </div>
      </AppPageFrame>
    );
  }

  private handleBackClick = () => {
    this.props.history.push("/administration");
  };
};

export const VideosIndexPage = withStyles(styles)(
  connect<VideosIndexPageStateProps, VideosIndexPageDispatchProps, VideosIndexPageOwnProps, ApplicationState>(
    (state) => ({
      administrationState: state.administration,
    }),
    (dispatch) => ({
      administrationActions: bindActionCreators(actionCreators.administration, dispatch),
    }),
  )(VideosIndexPageComponent),
);
